import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { createTheme } from "@mui/material";
import type {} from "@mui/x-date-pickers/themeAugmentation";

import {
  RECORD_TYPE_BADGE_COLORS,
  SECONDARY_TEXT_COLOR,
} from "./constants/colors";

/** Marks helptext popup content so only that Popover paper gets restyled. */
export const INFO_POPUP_CLASS = "vmd-info-popup";

export const theme = createTheme({
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          [`&:has(.${INFO_POPUP_CLASS})`]: {
            backgroundColor: "#fff",
            border: `1px solid ${RECORD_TYPE_BADGE_COLORS.businessApplication}`,
            borderRadius: "8px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          },
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        // These should boots the performance of the TextField components as GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount.
        // This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
        disableInjectingGlobalStyles: true,
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.Mui-selected": { color: "#fff" },
        },
      },
    },
  },
  typography: {
    fontFamily: "Roboto",
    h2: {
      fontWeight: 400,
      fontSize: "2.7rem",
    },
    h5: {
      fontSize: "1.25rem",
      lineHeight: "1.5rem",
      fontWeight: 500,
    },
    h6: {
      fontWeight: 400,
      fontSize: "17px",
    },
    caption: {
      color: SECONDARY_TEXT_COLOR,
      fontWeight: 400,
    },
    body1: {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: 400,
    },
    body2: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400,
    },
    button: {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 2,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#003781",
      contrastText: SECONDARY_TEXT_COLOR,
    },
    secondary: {
      main: RECORD_TYPE_BADGE_COLORS.businessApplication,
      dark: "#B5DAE6",
    },
    info: {
      light: "#EDE7F6",
      main: "#673AB7",
      contrastText: "#000000",
    },
    success: {
      light: "#00C85333",
      main: "#00C853",
    },
    warning: {
      light: "#FFEB3B80",
      main: "#FFEB3B",
    },
    text: {
      primary: "#2C3E50",
      secondary: "#000000",
    },
  },
});
